import { AsyncBoundary } from "@base/ui/AsyncBoundary";
import { Tabs } from "@base/ui/Tabs";
import { useTranslation } from "react-i18next";
import { AdminReservationBoard } from "./AdminReservationBoard";
import { MembersTab } from "./MembersTab";

const TAB_VALUES = ["members", "reservations"] as const;

export const AdminTabs = () => {
  const { t } = useTranslation();

  return (
    <Tabs layout="hug" color="primary" defaultValue={TAB_VALUES[0]}>
      <div className="sticky top-[58px] z-10 -mx-4 px-4 bg-white md:static md:top-0 md:z-auto md:mx-0 md:px-0">
        <Tabs.List>
          <Tabs.Trigger value="members" className="px-4 py-2 pb-4 text-gray-500 whitespace-nowrap text-label2">
            {t("adminMembers")}
          </Tabs.Trigger>
          <Tabs.Trigger value="reservations" className="px-4 py-2 pb-4 text-gray-500 whitespace-nowrap text-label2">
            {t("adminReservations")}
          </Tabs.Trigger>
        </Tabs.List>
      </div>

      <Tabs.Content value="members" className="py-8">
        <AsyncBoundary>
          <MembersTab />
        </AsyncBoundary>
      </Tabs.Content>
      <Tabs.Content value="reservations" className="py-8">
        <AsyncBoundary>
          <AdminReservationBoard />
        </AsyncBoundary>
      </Tabs.Content>
    </Tabs>
  );
};
